const swiperEestateCountries = new Swiper('.estate__countries__slider', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    pagination: {
      el: ".estate__countries-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".estate__countries-next",
      prevEl: ".estate__countries-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
    autoplay: {
      delay: 4000, 
      disableOnInteraction: false,
    },
});
